import React from "react";
import { Row, Col, Input, Button } from "reactstrap";
import { connect } from "react-redux";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import ContentEditable from "react-contenteditable";
import ReactDragList from "react-drag-list";
import "./ReactDragListStyle.css";
import { labelHelper } from "../../../helpers/labelHelper";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from "@material-ui/core";

class SelectAddItem extends React.Component {
  state = {
    optValue: "",
    addList: false
  };
  toggleInsertMode = () => {
    this.setState({ addList: !this.state.addList });
  };
  addOptions = () => {
    const { optValue } = this.state;
    this.props.onAdd(optValue);
    this.setState({ optValue: "" });
  };
  addOptionsAsList = () => {
    const { optValue } = this.state;
    this.props.onListAdd(optValue);
    this.setState({ optValue: "" });
  };
  handleChange = (value) => {
    this.setState({ optValue: value });
  };
  handleKeyDown = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      // You code when "Enter" is pressed
      if (this.state.optValue) {
        this.handleChange(e.target.value);
        this.addOptions();
      }
    }

  }

  render() {
    const { options } = this.props;
    return (
      <div style={{ padding: '10px 20px', maxWidth: '800px' }}>
        {options.length > 0 ? (
          <ReactDragList
            animation={10}
            dataSource={options}
            rowKey={"optionId"}
            className="sai-drag"
            rowClassName="rdl-row"
            handles={true}
            onUpdate={(event, dataSource) =>
              this.props.onOrderChange(event, dataSource)
            }
            row={(o, index) => {
              let label = "";
              if (o.labels) {
                label = o.labels.find(
                  ol => ol.languageCode === this.props.languageCode
                );
              } else {
                label = { text: o.value };
              }

              return (
                <Row
                  key={index}
                  style={{
                    width: "100%",
                    textDecorationLine: o.isDeleted
                      ? "line-through"
                      : undefined,
                    color: o.isDeleted ? "red" : undefined
                  }}
                >
                  <Col style={{ width: "auto", paddingTop: '5px', flexGrow: 0 }}>
                    <p /*  className="not-inflicted" */>{o.sortOrder}.</p>
                  </Col>
                  <Col style={{ paddingTop: '5px' }}>
                    <ContentEditable
                      innerRef={this.contentEditable}
                      html={label ? label.text : ""}
                      onBlur={e =>
                        this.props.onEdit(
                          e.target.innerHTML,
                          o.optionId,
                          this.props.languageCode
                        )
                      }
                      style={{ marginTop: '3px !important' }}
                      tagName="p"
                      className="ignore-click"
                    />
                  </Col>
                  <Col style={{ textAlign: "right", /* paddingTop: '5px', */ maxWidth: "10%" }}>
                    <IconButton onClick={e => this.props.onDelete(o.optionId, e)}
                      style={{
                        marginTop: '-10px',
                        cursor: "pointer"
                      }}>
                      <DeleteIcon />
                    </IconButton>
                   {/*  <i

                      className="fa fa-trash fa-1x ignore-click "

                    /> */}
                  </Col>
                </Row>
              );
            }}
          />
        ) : null}
        <Row>
          <Col>
            <Input
              type={this.state.addList ? "textarea" : "text"}
              className="ignore-click"
              autoComplete="jirango-nofill"
              value={this.state.optValue}
              style={{ resize: "none" }}
              onKeyUp={this.handleKeyDown}
              placeholder={labelHelper.getLabel("Option") + ".."}
              onChange={e => this.handleChange(e.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col style={{ display: "inline-flex", padding: '10px 15px' }}>
            <Button
              className="ignore-click"
              color="success"
              style={{ width: "100%", margin: "2px 5px 5px" }}
              disabled={!this.state.optValue}
              onClick={
                this.state.addList ? this.addOptionsAsList : this.addOptions
              }
            >
              <SystemLabel className="ignore-click" name="AddOption" />
            </Button>
            <Button
              className="ignore-click"
              style={{
                width: " 100%",
                margin: "2px 0px",
                backgroundColor: "#596574",
                border: "none",
                color: "#eee"
              }}
              /*  disabled={!this.state.optValue} */ onClick={
                this.toggleInsertMode
              }
            >
              <i className="fa fa-list" />{" "}
              <SystemLabel className="ignore-click" name="ListInsertion" />
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(SelectAddItem);
